import * as React from 'react';
import { useEffect, BaseSyntheticEvent } from 'react';
import styled from 'styled-components';


interface ScrollProps {
  children: React.ReactNode;
}

const ScrollStyle = ({ children }: ScrollProps) => {
  let scrollArea:Element | null;

  useEffect(() => {
    scrollArea && scrollArea.scrollHeight === 0 && handleBarSize(scrollArea);
  });

  return (
    <ScrollWrap className="scroll-wrap">
      <Scroll ref={div => scrollArea = div} onScroll={handleScroll}>
        {children}
      </Scroll>
      <ScrollHorizon className="scroll-axis axis-x" onMouseDown={e => clickBarHandler(e, 'x')}>
        <ScrollItem className="scroll-item" onMouseDown={e => clickThumbHandler(e, 'x')} />
      </ScrollHorizon>
      <ScrollVertical className="scroll-axis axis-y" onMouseDown={e => clickBarHandler(e, 'y')}>
        <ScrollItem className="scroll-item" onMouseDown={e => clickThumbHandler(e, 'y')} />
      </ScrollVertical>
    </ScrollWrap>
)};

const handleBarSize = (el:any) => {
  const { parentNode } = el;

  const widthPercent = (el.clientWidth * 100 / el.scrollWidth);
  const heightPercent = (el.clientHeight * 100 / el.scrollHeight);

  parentNode.querySelector('.axis-x > div').style.width = (widthPercent < 100) ? (widthPercent + '%') : '';
  parentNode.querySelector('.axis-y > div').style.height = (heightPercent < 100) ? (heightPercent + '%') : '';
}

const handleScroll = (e:BaseSyntheticEvent) => {
  const { target } = e;

  handleBarPosition(target, 'x', (target.scrollLeft * 100) / target.clientWidth);
  handleBarPosition(target, 'y', (target.scrollTop * 100) / target.clientHeight);
}

const handleBarPosition = (el: any, xy: string, move: number) => {
  const translate = `translate${xy.toUpperCase()}(${move}%)`;
  const scrollItem = el.parentNode.querySelector(`.axis-${xy}`).childNodes[0];

  scrollItem.style.transform = translate;
  scrollItem.style.msTransform = translate;
  scrollItem.style.webkitTransform = translate;
}

const scrollMap = {
  y: {
    client: 'clientY',
    direction: 'top',
    offset: 'offsetHeight',
    scroll: 'scrollTop',
    scrollSize: 'scrollHeight',
    size: 'height',
  },
  x: {
    client: 'clientX',
    direction: 'left',
    offset: 'offsetWidth',
    scroll: 'scrollLeft',
    scrollSize: 'scrollWidth',
    size: 'width',
  }
}

let axis:string;
const scroll = { cursor: false };
let scrollTarget:any;

const clickBarHandler = (e:BaseSyntheticEvent, xy:string) => {
  axis = xy;

  if (!scrollTarget) { return };

  const thumb =  scrollTarget.parentNode.querySelector(`.axis-${axis} > .scroll-item`);
  const offset = Math.abs(thumb.parentNode.getBoundingClientRect()[scrollMap[axis].direction] - e[scrollMap[axis].client]);
  const thumbHalf = (thumb[scrollMap[axis].offset] / 2);

  const thumbPercent = ((offset - thumbHalf) * 100 / thumb[scrollMap[axis].offset]);

  scrollTarget = thumb.parentNode.parentNode.childNodes[0];
  scrollTarget[scrollMap[axis].scroll] = (thumbPercent * thumb.parentNode[scrollMap[axis].scrollSize] / 100);
}

const clickThumbHandler = (e:BaseSyntheticEvent, xy:string) => {
  axis = xy;
  scrollTarget = e.target.parentNode.parentNode.childNodes[0];
  DragOn(e);
  scroll[axis.toUpperCase()] = (e.target[scrollMap[axis].offset] - (e[scrollMap[axis].client] - e.target.getBoundingClientRect()[scrollMap[axis].direction]));
}

const DragOn = (e:BaseSyntheticEvent) => {
  e.isPropagationStopped();
  scroll.cursor = true;

  document.addEventListener('mousemove', moveHandler);
  document.addEventListener('mouseup', upHandler);
  document.onselectstart = () => false;
}

const moveHandler = (e:any) => {
  if (scroll.cursor === false) { return; }
  const prevPage = scroll[axis.toUpperCase()];

  if (!prevPage) { return; }

  const thumb = scrollTarget.parentNode.querySelector(`.axis-${axis} > .scroll-item`);
  const offset = ((thumb.parentNode.getBoundingClientRect()[scrollMap[axis].direction] - e[scrollMap[axis].client]) * -1);
  const thumbPosition = (thumb[scrollMap[axis].offset] - prevPage);
  const thumbPercent = ((offset - thumbPosition) * 100 / thumb.parentNode[scrollMap[axis].offset]);

  scrollTarget[scrollMap[axis].scroll] = (thumbPercent * scrollTarget[scrollMap[axis].scrollSize] / 100);
}

const upHandler = () => {
  document.removeEventListener('mousemove', moveHandler);
  document.removeEventListener('mouseup', upHandler);
  scroll.cursor = false;
  scroll[axis] = 0;
  document.onselectstart = null;
}


export default ScrollStyle;

const FuncScroll = () => {
  let resultShape = '';
  if (window.navigator.userAgent.indexOf('Edge') > -1 || window.navigator.userAgent.indexOf('rv:11.0') > -1) {
    resultShape = 'margin-right: -17px; margin-bottom: -17px;';
  }
  return resultShape;
};


const ScrollWrap = styled.div`
  overflow: hidden;
`;

const Scroll = styled.div`
  position: relative;
  overflow: scroll;
  ${p => FuncScroll()}
`;

const ScrollHorizon = styled.div`
  position: absolute;
  bottom: 0; left: 0;
  width: 100%; height: 8px;
  z-index: 10;

  & > div {
    width: 0; height: 5px;
  }
`;

const ScrollVertical = styled.div`
  position: absolute;
  top: 0; right: 0;
  width: 8px; height: 100%;
  z-index: 10;

  & > div {
    width: 5px; height: 0;
  }
`;

const ScrollItem = styled.div`
  box-sizing: content-box;
  border-radius: 3px;
  background-color: #b6aa92;
`;


// WEBPACK FOOTER //
// ./src/styles/ui/Scroll.tsx